module.exports = __webpack_public_path__ + "img/newsImg7.9c20075e.png";